import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import md5 from 'js-md5'
import qs from 'qs'
import 'element-ui/lib/theme-chalk/index.css'
import '@/elementUI/index.css'
import '@/style/global.css'
import * as echarts from 'echarts';

Vue.use(ElementUI)
Vue.use(echarts)
Vue.prototype.$qs = qs
Vue.prototype.$md5 = md5
Vue.config.productionTip = false

new Vue({
    // 挂载
    store,
    router,
    render: h => h(App)
}).$mount('#app')
